<template>
	<div id="cart-page" class="d-flex account-page">
		<div class="container main-box">
			<div class="row">
				<div class="col-12 px-2">
					<h1 class="mb-3 page-title">Mi carrito</h1>
				</div>

				<div class="col-lg px-2 col-menu">
					<div class="white-box">
						<div class="box-menu py-2">
							<div class="item">
								<router-link class="btn-menu" to="/cart/items">
									<i class="fas fa-shopping-cart"></i>
									Mi carrito
								</router-link>
							</div>

							<div class="item" :class="{ disabled: !isCartReady }" >
								<router-link class="btn-menu" to="/cart/address" :is="isCartReady ? 'router-link' : 'span'" >
									<i class="fas fa-map"></i>
									Domicilio de entrega
								</router-link>
							</div>

							<!-- <div class="item" :class="{ disabled: !cartGetAddressIsValid }" >
								<router-link class="btn-menu" to="/cart/payment" :is=" !cartGetAddressIsValid ? 'span' : 'router-link' " >
									<i class="fas fa-credit-card"></i>
									Método de pago
								</router-link>
							</div> -->

							<div class="item" :class="{ disabled: !isSummaryReady }" >
								<router-link class="btn-menu" to="/cart/summary" :is=" isSummaryReady ? 'router-link' : 'span' " >
									<i class="fas fa-truck"></i>
									Resumen de compra
								</router-link>
							</div>
						</div>
					</div> 
				</div>

				<div class="col-lg px-2 col-cart-data" v-if="isCart">
					<!-- <div class="white-box"> -->
					<b-form class="white-box" @submit.prevent="">
						<!-- Paso 1 (Lista de productos agregados a carrito) -->
						<div class="col-12 pt-3 product-list-table">
							<div class="col-12 px-0">

								<h5>Productos agregados al carrito</h5>

								<h6 class="mt-4 pb-4 f-w-400 text-warning" v-if="!cartGetItems.length" >
									<i class="fas fa-shopping-cart"></i>
									Ningun producto ha sido agregado al carrito
								</h6>

							</div>

							<div class="row row-products" v-for="(product, index) in cartGetItems" :key="index + '-' + product" >
								<product-in-cart :product-id="product" :index-in-cart="index" />
							</div>
						</div>
						<!-- paso 1, Fin -->
					</b-form>
				</div>

				<div class="col-lg px-2 col-cart-data" v-if="isFail">
					<h1>
						Ocurrió un error al procesar el pago...
					</h1>
				</div>

				<div class="col-lg px-2 col-cart-data" v-if="isAddress">
					<deliveryaddress ref="deliverAddress" class="white-box p-3" />
				</div>

				<div class="col-lg px-2 col-cart-data" v-if="isSummary">
					<present-summary-item class="white-box p-3" />
					<hr>
					<deliveryaddress ref="deliverAddress" class="white-box p-3" :readonly="true"/>
					<hr>
					<cart-payment-methods ref="cartPaymentMethod" class="white-box p-3" />
				</div>
			</div>

			<div class="row-total mt-3" v-if="isCartReady">
				<div class="text-right">
					<h6>
						<span>Subtotal: </span>
						{{ cartGetTotal | currency }}
					</h6>
					<h6 v-if="!!cartGetAddress.envio">
						<span>Envío: </span>
						{{ cartGetAddress.envio | currency }}
					</h6>
					<h5 v-if="!!cartGetAddress.envio">
						<span>Total: </span>
						{{ (cartGetAddress.envio + cartGetTotal) | currency }}
					</h5>
					<div class="mt-3">

						<button class="btn btn-primary" v-if="!isLogged" @click="$router.push('/login')">
							Inicia sesión para continuar
						</button>

						<button class="btn btn-primary" v-else-if="isProcessing" key="procesing" disabled>
							Procesando...
						</button>

						<button class="btn btn-primary" v-else key="next" @click="nextStep">
							<span key="toAddress" v-if="isCart">Continuar al domicilio de entrega</span>
							<span key="toPayment" v-if="isAddress">Continuar al método de pago</span>
							<span key="toProcess" v-if="isSummary">Finalizar pedido</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from "vuex";
	
	import presentSummaryItem from "./summary.vue";
	import ProductInCart from "../daniel/product-in-cart";
	import Deliveryaddress from "./deliveryaddress.vue";
	import CartPaymentMethods from './cart-payment-methods.vue';
	import SummaryAddress from './summary-address.vue';

	export default {
		components: { ProductInCart, Deliveryaddress, presentSummaryItem, CartPaymentMethods, SummaryAddress },
		name: "Cart",
		data: () => {
			return {
				isProcessing: false,
				form: {
					products: [],
				},
			};
		},
		computed: {
			...mapGetters([
				"cartGetItems",
				"cartGetTotal",
				"isLogged",
				"cartGetAddress",
				"cartGetAddressIsValid",
			]),
			isCartReady() {
				return this.cartGetItems.length;
			},
			isSummaryReady() {
				return (this.isCartReady && this.cartGetAddressIsValid);
			},
			isFail() {
				return this.$route.params.step == "fail";
			},
			isCart() {
				return this.$route.params.step == "items";
			},
			isAddress() {
				return this.$route.params.step == "address";
			},
			isSummary() {
				return this.$route.params.step == "summary";
			},
		},
		methods: {
			async nextStep() {
				switch (this.$route.params.step) {
					case "items":
						this.isProcessing = true;
						this.$router.push({ params: { step: "address" } });
						this.isProcessing = false;
						break;
				
					case "address":
						this.isProcessing = true;
						let resp = await this.$refs.deliverAddress.triggerAddData();
						if (resp) this.$router.push({ params: { step: "summary" } });
						this.isProcessing = false;
						break;
				
					case "summary":
						this.processOrder();		
						break;
				}
			},
			processOrder(){
				this.isProcessing = true;
				this.$refs.cartPaymentMethod.processCartCardPurchase().then(() => {
					this.$router.replace("/usuario/mis-pedidos");
				}).catch((resp)=>{
					console.error("resp", resp)
					this.isProcessing = false;
				});
			}
		},
		beforeMount() {
			this.$router.replace("/cart/items");
		}
	};
</script>

<style lang="less">
#cart-page {
	.white-box {
		.item {
			&.disabled {
				background: #cacaca;
				color: #8c8c8c;
				opacity: 0.5;
			}
		}
	}
}

.btn-primary.disabled,
.btn-primary:disabled {
	background-color: var(--primary);
	border-color: var(--primary);
}
</style>